import React, {
    useMemo,
    useState,
    useCallback,
    useRef,
    useEffect
} from "react";
import { AgGridReact } from "ag-grid-react";
import './Modal.css';
import {
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Dialog,
    DialogTitle,
    DialogActions,
} from "@mui/material";
import "./SettingConfig.css"
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../../components/common/datatable/DataTable.css";
import TopSection from "../LT/TopSection";
import { MultiDropdown } from "../../components/common/MultiDropdown";
import ButtonComponent from "../../components/common/button/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { deletePlantLevelConfigEndpoint, dropdownPlantLevelConfigEndpoint, getBuyerDropdownFilterEndpoint, getPlantLevelConfigEndpoint, postPlantLevelConfigEndpoint, putPlantLevelConfigEndpoint, serachPlantLevelConfigEndpoint } from "../../common/endpoints";
import { getPlantLevelConfigSlice } from "../../redux/actions/getPlantLevelConfigSlice";
import { postPlantLevelConfigSlice } from "../../redux/actions/postPlantLevelConfigSlice";
import { deletePlantLevelConfigSlice } from "../../redux/actions/deletePlantLevelConfigSlice";
import { putPlantLevelConfigSlice } from "../../redux/actions/putPlantLevelConfigSlice";
import { dropdownPlantLevelConfigSlice } from "../../redux/actions/dropdownPlantLevelConfigSlice";
import { serachPlantLevelConfigSlice } from "../../redux/actions/serachPlantLevelConfigSlice";
import { getBuyerDropdownFilter } from "../../redux/actions/BuyerDropdownFilterSlice";
import AddPlantConfigurationModal from "./AddPlantConfigurationModal";
import { Loader } from "../../components/common/Loader";
import Dropdown from "../../components/common/Dropdown";
import { TitleRounded } from "@mui/icons-material";
import ForecastPublishExclusion from "./ForecastPublishExclusion";

const ForecastReviewPeriodConfig = () => {
    const [allData, setAllData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const [plantOptions, setPlantOptions] = useState([]);
    const [parentVendorOptions, setParentVendorOptions] = useState([]);
    const [childVendorOptions, setChildVendorOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const loggedInUserEmail = localStorage.getItem("userEmail");
    const gridRef = useRef(null);
    const dispatch = useDispatch();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [editRow, setEditRow] = useState(null);
    const pagination = true;
    const paginationPageSize = 100;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
    const roleDetails = localStorage.getItem("userRole");
    const isAppAdmin = roleDetails === "App Admin";
    const [selectedSettingsPage, setSelectedSettingsPage] = useState("/settings-config/forecast-review-period");

    const searchLoading = useSelector(
        (state) => state.serachPlantLevelConfigSlice
    );

    const plantConfigSelector = useSelector(
        (state) => state.getPlantLevelConfigSlice
    );

    const [filters, setFilters] = useState({
        plant: [],
        parentVendor: [],
        childVendor: [],
        category: [],
    });

    const gridOptions = {
        // onFilterChanged,
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        }

    }

    const onAddPlantConfig = () => {
        setOpenAddModal(true);
    };

    const isSearchEnabled =
        filters.plant.length > 0 ||
        filters.parentVendor.length > 0 ||
        filters.childVendor.length > 0 ||
        filters.category.length > 0;

    // ---------------------------
    // Add new editable row
    // ---------------------------
    // const onAddPlantConfig = () => {
    //     const newRow = {
    //         id: Date.now(),
    //         plantCode: "",
    //         parentVendorName: "",
    //         childVendorId: "",
    //         reviewPeriod: "",
    //         lastUpdated: "",
    //         updatedBy: "",
    //         isNew: true,
    //         isEditing: true,
    //         isModified: true,
    //     };

    //     setRowData((prev) => [newRow, ...prev]);

    //     setTimeout(() => {
    //         gridRef.current?.api?.startEditingCell({
    //             rowIndex: 0,
    //             colKey: "plantCode",
    //         });
    //     }, 100);
    // };

    // const handleCancelNewRow = (rowId) => {
    //     setRowData((prev) =>
    //         prev.filter((row) => row.id !== rowId)
    //     );
    // };


    // ---------------------------
    // Validation rule
    // ---------------------------
    const isRowValid = (row) => {
        const hasOneEntity =
            !!row.plantCode?.toString().trim() ||
            !!row.parentVendorName?.toString().trim() ||
            !!row.childVendorId?.toString().trim();

        const hasReviewPeriod =
            row.reviewPeriod !== "" &&
            row.reviewPeriod !== null &&
            row.reviewPeriod !== undefined &&
            !isNaN(row.reviewPeriod);

        return hasOneEntity && hasReviewPeriod;
    };

    useEffect(() => {
        getDropdownData();
        getPlantLevelConfigList();
    }, []);

    // const isSaveEnabled = useMemo(() => {
    //     const newRows = rowData.filter(row => row.isNew);

    //     if (newRows.length === 0) return false;

    //     return newRows.every((row) => {
    //         const hasOneEntity =
    //             !!row.plantCode?.toString().trim() ||
    //             !!row.parentVendorName?.toString().trim() ||
    //             !!row.childVendorId?.toString().trim();

    //         const hasReviewPeriod =
    //             row.reviewPeriod !== "" &&
    //             row.reviewPeriod !== null &&
    //             row.reviewPeriod !== undefined &&
    //             !isNaN(row.reviewPeriod);

    //         return hasOneEntity && hasReviewPeriod;
    //     });
    // }, [rowData]);

    const handleAddConfigurations = async (rows) => {
        const payload = rows.map((row) => {
            const isBulk =
                Array.isArray(row.plantIds) && row.plantIds.length > 0;

            // ✅ BULK MODE

            return {
                userEmail: loggedInUserEmail,
                plantIds: row.plantIds,
                plantName: row.plantNames || "",
                parentVendorIds: row.parentVendorIds || [],
                parentVendorName: row.parentVendorNames || "",
                childVendorIds: row.childVendorIds || [],
                childVendorName: row.childVendorNames || "",
                businessCategories: row.businessCategories || "",
                reviewPeriodDays: Number(row.reviewPeriodDays ?? row.reviewPeriod ?? 0)
            };


            // ✅ SINGLE MODE (your actual case)
            // return {
            //     userEmail: loggedInUserEmail,
            //     plantId: row.plantId,
            //     plantName: row.plantName,
            //     parentVendorId: row.parentVendorId || "",
            //     parentVendorName: row.parentVendorName || "",
            //     childVendorId: row.childVendorId || "",
            //     businessCategory: row.businessCategory || "",
            //     reviewPeriodDays: Number(row.reviewPeriodDays || row.reviewPeriod)
            // };
        });
        const response = await dispatch(
            postPlantLevelConfigSlice({
                dynamicEndpoint: postPlantLevelConfigEndpoint,
                data: payload,
            })
        );

        if (response?.meta?.requestStatus === "fulfilled") {
            toast.success("Configuration added successfully");
            setOpenAddModal(false);
            getPlantLevelConfigList();
        } else {
            toast.error(response.payload?.message || "Configuration already exists");
        }
    };
    const getUniqueValues = (arr) => [...new Set(arr.filter(Boolean))];

    // ---------------------------
    // Column definitions
    // ---------------------------

    const columnDefs = useMemo(
        () => [
            {
                field: "plantDisplay",
                headerName: "Plant Code",
                width: 120,
                editable: (params) => params.data?.isEditing,
                cellEditor: "agSelectCellEditor",
                cellEditorParams: {
                    values: ["", ...getUniqueValues(plantOptions.map(v => v.value))],
                }
            },
            {
                field: "parentVendorDisplay",
                headerName: "Parent Vendor",
                width: 120,
                editable: (params) => params.data?.isEditing,
                cellEditor: "agSelectCellEditor",
                cellEditorParams: (params) => {
                    const selectedPlant = params.data?.plantCode;
                    const filtered = allData
                        .filter(r => !selectedPlant || r.plant === selectedPlant)
                        .map(r => r.parentVendor)
                        .filter(Boolean);
                    const unique = [...new Set(filtered)];
                    return {
                        values: ["", ...unique]
                    };
                }
            },
            {
                field: "childVendorDisplay",
                headerName: "Child Vendor Id",
                width: 150,
                editable: (params) => params.data?.isEditing,
                cellEditor: "agSelectCellEditor",
                cellEditorParams: (params) => {
                    const plant = params.data?.plantCode;
                    const parent = params.data?.parentVendorName;
                    const filtered = allData.filter(r =>
                        (!plant || r.plant === plant) &&
                        (!parent || r.parentVendor === parent)
                    );
                    const unique = [...new Set(filtered.map(r => r.vendorCode))];
                    return {
                        values: ["", ...unique]
                    };
                }
            },
            {
                field: "businessCategory",
                headerName: "Business Category",
                editable: (params) => params.data?.isEditing,
                width: 140,
                cellEditor: "agSelectCellEditor",
                cellEditorParams: (params) => {
                    const plant = params.data?.plantCode;
                    const parent = params.data?.parentVendorName;
                    const child = params.data?.childVendorId;
                    const filtered = allData.filter(r =>
                        (!plant || r.plant === plant) &&
                        (!parent || r.parentVendor === parent) &&
                        (!child || r.vendorCode === child)
                    );
                    const unique = [...new Set(filtered.map(r => r.businessCategory))];
                    return {
                        values: ["", ...unique]
                    };
                },
            },
            {
                field: "reviewPeriod",
                headerName: "Review Period (Days)",
                width: 120,
                autoHeight: true,

            },

            {
                field: "lastUpdated",
                headerName: "Last Updated Date",
                width: 120,
                valueFormatter: (params) => {
                    return params.value ? params.value.split("T")[0] : "";
                }
            },

            {
                field: "updatedBy",
                headerName: "Updated By",
                width: 120,
            },

            ...(!isAppAdmin
                ? []
                : [
                    {
                        headerName: "Actions",
                        width: 160,
                        cellRenderer: (params) => {
                            const row = params.data;

                            return (
                                <div style={{ display: "flex", gap: 6 }}>

                                    {!row.isNew && (
                                        <IconButton
                                            size="small"
                                            disableRipple
                                            sx={{
                                                backgroundColor: "transparent !important",

                                                "&:hover": {
                                                    backgroundColor: "transparent !important",
                                                },

                                                "&:focus": {
                                                    backgroundColor: "transparent !important",
                                                },

                                                "&:active": {
                                                    backgroundColor: "transparent !important",
                                                },

                                                "& .MuiSvgIcon-root": {
                                                    color: "#1976d2 !important",
                                                    opacity: "1 !important",
                                                    visibility: "visible !important",
                                                },

                                                "&:hover .MuiSvgIcon-root": {
                                                    color: "#1976d2 !important",
                                                    opacity: "1 !important",
                                                    visibility: "visible !important",
                                                },
                                            }}
                                            onClick={() => {
                                                const row = params.data;

                                                setEditRow({
                                                    id: row.id,

                                                    // ✅ PLANT
                                                    plantCode: row.plantCode
                                                        ? [{
                                                            value: row.plantCode,
                                                            label: `${row.plantCode} | ${row.plantName}`
                                                        }]
                                                        : [],

                                                    // ✅ PARENT VENDOR
                                                    parentVendorId: row.parentVendorId
                                                        ? [{
                                                            value: row.parentVendorId,
                                                            label: row.parentVendorName
                                                                ? `${row.parentVendorId} | ${row.parentVendorName}`
                                                                : row.parentVendorId
                                                        }]
                                                        : [],

                                                    // ✅ CHILD VENDOR
                                                    childVendorId: row.childVendorId
                                                        ? [{
                                                            value: row.childVendorId,
                                                            label: row.childVendorName
                                                                ? `${row.childVendorId} | ${row.childVendorName}`
                                                                : row.childVendorId
                                                        }]
                                                        : [],

                                                    // ✅ CATEGORY
                                                    businessCategory: row.businessCategory
                                                        ? [{
                                                            value: row.businessCategory,
                                                            label: row.businessCategory
                                                        }]
                                                        : [],

                                                    // ✅ REVIEW (normal input)
                                                    reviewPeriod: row.reviewPeriod
                                                });

                                                setOpenAddModal(true);
                                            }}
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    )}

                                    {/* SAVE BUTTON ONLY FOR EXISTING EDIT ROW */}
                                    {row.isEditing && !row.isNew && (
                                        <ButtonComponent
                                            type="secondary"
                                            minWidth="100px"
                                            label="Save"
                                            height="36px"
                                            disabled={!isRowValid(row) || !row.isModified}
                                            onClick={() => handleEditSave(row)}
                                        />
                                    )}

                                    {/* DELETE BUTTON ONLY FOR EXISTING ROWS */}
                                    {!row.isNew && (
                                        <IconButton
                                            size="small"
                                            disableRipple
                                            onClick={() => {
                                                setDeleteRow(row);
                                                setShowDelete(true);
                                            }}
                                            sx={{
                                                backgroundColor: "transparent !important",
                                                color: "#d32f2f !important",
                                                "&:hover": {
                                                    backgroundColor: "transparent !important",
                                                    color: "#d32f2f !important",
                                                },
                                                "&:focus": {
                                                    backgroundColor: "transparent !important",
                                                    color: "#d32f2f !important",
                                                },
                                                "&:active": {
                                                    backgroundColor: "transparent !important",
                                                    color: "#d32f2f !important",
                                                },
                                            }}
                                        >
                                            <DeleteIcon
                                                fontSize="small"
                                                sx={{
                                                    color: "#d32f2f !important",
                                                }}
                                            />
                                        </IconButton>
                                    )}
                                </div>
                            )
                        }
                    }
                ]
            )
        ],
        [plantOptions, parentVendorOptions, childVendorOptions, categoryOptions, rowData]
    );

    const onCellValueChanged = (params) => {
        const updatedRow = {
            ...params.data,
            isModified: true,
        };

        setRowData((prev) =>
            prev.map((row) =>
                row.id === updatedRow.id ? updatedRow : row
            )
        );
    };

    const formatCodeName = (code, name) => {
        if (!code) return "";
        if (!name) return code;   // 👈 no "|" if name missing
        return `${code} | ${name}`;
    };

    const buildSavePayload = () => {
        return rowData
            .filter((row) => row.isNew)
            .filter(isRowValid)
            .map((row) => ({
                plantId: row.plantCode || "",
                plantName: row.plantName || "",
                reviewPeriodDays: row.reviewPeriod || 0,
                userEmail: loggedInUserEmail,
                childVendorId: row.childVendorId || "",
                parentVendorId: row.parentVendorId || "",
                parentVendorName: row.parentVendorName || "",
                businessCategory: row.businessCategory || "",
            }));
    };

    const buildUpdatePayload = (row) => {
        return {
            plantId: row.plantCode,
            plantName: row.plantName || "",
            businessCategory: row.businessCategory || "",
            reviewPeriodDays: Number(row.reviewPeriod),
            userEmail: loggedInUserEmail,
            childVendorId: row.childVendorId,
            childVendorName: row.childVendorName,
            parentVendorId: row.parentVendorId,
            parentVendorName: row.parentVendorName,
            lastUpdatedBy: loggedInUserEmail,
        };
    };

    const getFilteredOptions = (currentField, optionList, valueKey) => {
        const filteredRows = allData.filter(row => {
            return (
                (currentField === "plant" ||
                    !filters.plant.length ||
                    filters.plant.some(f => f.value === row.plant)) &&

                (currentField === "parentVendor" ||
                    !filters.parentVendor.length ||
                    filters.parentVendor.some(f => f.value === row.parentVendor)) &&

                (currentField === "childVendor" ||
                    !filters.childVendor.length ||
                    filters.childVendor.some(f => f.value === row.vendorCode)) &&

                (currentField === "category" ||
                    !filters.category.length ||
                    filters.category.some(f => f.value === row.businessCategory))
            );
        });

        const allowedValues = new Set(
            filteredRows
                .map(row => row[valueKey])
                .filter(Boolean)
        );

        return optionList.filter(opt =>
            allowedValues.has(opt.value)
        );
    };

    const filteredPlantOptions = useMemo(
        () => getFilteredOptions("plant", plantOptions, "plant"),
        [filters, plantOptions, allData]
    );

    const filteredParentVendorOptions = useMemo(
        () => getFilteredOptions(
            "parentVendor",
            parentVendorOptions,
            "parentVendor"
        ),
        [filters, parentVendorOptions, allData]
    );

    const filteredChildVendorOptions = useMemo(
        () => getFilteredOptions(
            "childVendor",
            childVendorOptions,
            "vendorCode"
        ),
        [filters, childVendorOptions, allData]
    );

    const filteredCategoryOptions = useMemo(
        () => getFilteredOptions(
            "category",
            categoryOptions,
            "businessCategory"
        ),
        [filters, categoryOptions, allData]
    );

    const getPlantLevelConfigList = async () => {
        try {

            const response = await dispatch(
                getPlantLevelConfigSlice({
                    dynamicEndpoint: getPlantLevelConfigEndpoint,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const list = response?.payload || [];
                const formattedData = list.map((item) => ({
                    id: item.id,

                    plantCode: item.plantId || "",

                    plantName: item.plantName || "",

                    parentVendorName: item.parentVendorName || "",
                    parentVendorId: item.parentVendorId || "",   // ✅ ADD THIS
                    childVendorId: item.childVendorId || "",
                    childVendorName: item.childVendorName || "",
                    plantDisplay: formatCodeName(item.plantId, item.plantName),

                    parentVendorDisplay: formatCodeName(
                        item.parentVendorId,
                        item.parentVendorName
                    ),

                    childVendorDisplay: formatCodeName(
                        item.childVendorId,
                        item.childVendorName
                    ),
                    reviewPeriod: item.reviewPeriodDays ?? 0,

                    businessCategory: item.businessCategory || "",

                    updatedBy: item.lastUpdatedBy || "",

                    lastUpdated: item.lastUpdatedDatetime || "",

                    isNew: false,
                    isEditing: false,
                    isModified: false
                }));

                setRowData(formattedData);
            }

        } catch (error) {
            console.error("Plant Config API error:", error);
        }

    };

    const getDropdownData = async () => {
        try {
            const response = await dispatch(
                getBuyerDropdownFilter({
                    dynamicEndpoint: `${getBuyerDropdownFilterEndpoint}/${loggedInUserEmail}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const list = response?.payload || [];
                setAllData(list)
                // PLANT
                setPlantOptions(
                    Array.from(
                        new Map(
                            list.map(item => [
                                item.plant,
                                {
                                    value: item.plant,
                                    label: `${item.plant} | ${item.plantName}`,
                                    title: `${item.plant} | ${item.plantName}`
                                }
                            ])
                        ).values()
                    )
                );

                // PARENT VENDOR
                setParentVendorOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.parentVendor)
                                .map(item => [
                                    item.parentVendor,
                                    {
                                        value: item.parentVendor,
                                        label: item.parentVendorName
                                            ? `${item.parentVendor} | ${item.parentVendorName}`
                                            : item.parentVendor,
                                        title: item.parentVendorName
                                            ? `${item.parentVendor} | ${item.parentVendorName}`
                                            : item.parentVendor
                                    }
                                ])
                        ).values()
                    )
                );

                // CHILD VENDOR
                setChildVendorOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.vendorCode)
                                .map(item => [
                                    item.vendorCode,
                                    {
                                        value: item.vendorCode,
                                        label: item.supplierName
                                            ? `${item.vendorCode} | ${item.supplierName}`
                                            : item.vendorCode,
                                        title: item.supplierName
                                            ? `${item.vendorCode} | ${item.supplierName}`
                                            : item.vendorCode
                                    }
                                ])
                        ).values()
                    )
                );

                // CATEGORY
                setCategoryOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.businessCategory)
                                .map(item => [
                                    item.businessCategory,
                                    {
                                        value: item.businessCategory,
                                        label: item.businessCategory,
                                        title: item.businessCategory
                                    }
                                ])
                        ).values()
                    )
                );
            }

        } catch (error) {
            console.error("Dropdown API error:", error);
        }
    };

    // const handleSave = async () => {
    //     const payload = buildSavePayload();

    //     if (!payload.length) {
    //         toast.error("No valid data to save", {
    //             autoClose: 2000,
    //         });
    //         return;
    //     }

    //     try {
    //         const response = await dispatch(
    //             postPlantLevelConfigSlice({
    //                 dynamicEndpoint: postPlantLevelConfigEndpoint,
    //                 data: payload
    //             })
    //         );

    //         if (response?.meta?.requestStatus === "fulfilled") {

    //             toast.success(
    //                 response?.payload?.message || "Saved successfully",
    //                 {
    //                     autoClose: 2000,
    //                 }
    //             );

    //             const updatedRows = rowData.map((row) => ({
    //                 ...row,
    //                 isNew: false,
    //                 isEditing: false,
    //                 lastUpdated: new Date().toISOString(),
    //                 updatedBy: loggedInUserEmail
    //             }));

    //             setRowData(updatedRows);
    //             getPlantLevelConfigList()

    //             // setIsSaved(true); // disables save button
    //         } else {
    //             toast.error(
    //                 response?.payload?.errorMessage || "Save failed",
    //                 {
    //                     autoClose: 2000,
    //                 }
    //             );
    //         }

    //     } catch (error) {
    //         console.error("API error:", error);

    //         toast.error("Something went wrong", {
    //             autoClose: 2000,
    //         });
    //     }
    // };

    // ---------------------------
    // Delete flow
    // ---------------------------
    const confirmDelete = async () => {
        try {
            if (!deleteRow?.id) return;

            const response = await dispatch(
                deletePlantLevelConfigSlice({
                    dynamicEndpoint: `${deletePlantLevelConfigEndpoint}/${deleteRow.id}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                toast.success(
                    response?.payload?.message ||
                    "Plant level configuration deleted successfully",
                    { autoClose: 2000 }
                );

                // remove from UI after success
                setRowData((prev) =>
                    prev.filter((r) => r.id !== deleteRow.id)
                );
            } else {
                toast.error(
                    response?.payload?.errorMessage || "Delete failed",
                    { autoClose: 2000 }
                );
            }
        } catch (error) {
            toast.error("Something went wrong while deleting", {
                autoClose: 2000,
            });
        } finally {
            setShowDelete(false);
            setDeleteRow(null);
        }
    };

    const handleEditSave = async (row) => {

        const payload = {
            userEmail: loggedInUserEmail,

            plantId: row.plantId
            ,
            plantName: row.plantName,

            parentVendorId: row.parentVendorId,
            parentVendorName: row.parentVendorName,

            childVendorId: row.childVendorId,
            childVendorName: row.childVendorName,
            businessCategory: row.businessCategory,

            reviewPeriodDays: Number(row.reviewPeriodDays || 0),
        };

        const response = await dispatch(
            putPlantLevelConfigSlice({
                dynamicEndpoint: `${putPlantLevelConfigEndpoint}/${row.id}`,
                data: payload,
            })
        );

        if (response?.meta?.requestStatus === "fulfilled") {
            toast.success("Updated successfully");
            setOpenAddModal(false);
            setEditRow(null);
            getPlantLevelConfigList();
        } else {
            toast.error(response?.payload?.errorMessage || "Updated failed");
        }
    };

    const handleSearch = async () => {
        try {

            const params = new URLSearchParams();

            // PLANT (multi)
            filters.plant?.forEach(item => {
                params.append("plantId", item.value);
            });

            // PARENT + CHILD VENDOR (same key: vendorId as backend expects)
            filters.parentVendor?.forEach(item => {
                params.append("vendorId", item.value);
            });

            filters.childVendor?.forEach(item => {
                params.append("vendorId", item.value);
            });

            // CATEGORY (single or multi depending backend)
            filters.category?.forEach(item => {
                params.append("businessCategory", item.value);
            });

            const endpoint =
                `${serachPlantLevelConfigEndpoint}?${params.toString()}`;

            const response = await dispatch(
                serachPlantLevelConfigSlice({
                    dynamicEndpoint: endpoint,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const list = response?.payload || [];

                const formattedData = list.map((item) => ({
                    id: item.id,
                    plantCode: item.plantId || "",
                    plantName: item.plantName || "",
                    parentVendorName: item.parentVendorName || "",
                    childVendorId: item.childVendorId || "",
                    plantDisplay: formatCodeName(item.plantId, item.plantName),

                    parentVendorDisplay: formatCodeName(
                        item.parentVendorId,
                        item.parentVendorName
                    ),

                    childVendorDisplay: formatCodeName(
                        item.childVendorId,
                        item.childVendorName
                    ),
                    reviewPeriod: item.reviewPeriodDays ?? 0,
                    updatedBy: item.lastUpdatedBy || "",
                    businessCategory: item.businessCategory || "",
                    lastUpdated: item.lastUpdatedDatetime || "",
                    isNew: false,
                    isEditing: false,
                    isModified: false,
                }));

                setRowData(formattedData);
            }

        } catch (error) {
            console.error("Search API error:", error);
        }
    };

    const handleSelectedSettingsPageChange = (name, event) => {
        const selectedValue = event.target.value;
        setSelectedSettingsPage(selectedValue);
    };

    const handleSelectedItemsChange = (name, newSelectedItems) => {
        const optionMap =
            name === "plant" ? plantOptions :
                name === "parentVendor" ? parentVendorOptions :
                    name === "childVendor" ? childVendorOptions :
                        name === "category" ? categoryOptions :
                            [];

        const normalized = newSelectedItems
            .map(sel => optionMap.find(opt => opt.value === sel.value))
            .filter(Boolean);

        setFilters((prev) => ({
            ...prev,
            [name]: normalized,
        }));
    };

    const handleReset = async () => {
        setFilters({
            plant: [],
            parentVendor: [],
            childVendor: [],
            category: [],
        });

        // reload full list
        getPlantLevelConfigList();
    };

    return (
        <div style={{ padding: 20, background: "#f5f6fa", minHeight: "100vh" }}>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Settings & Config" },
                ]}
                tabTitle="Settings & Config"
                moduleTitle="Settings & Config"
                hideTitle={true}
            />

            <div style={{
                display: "flex",
                flexDirection: "row",
                fontSize: 22,
                fontWeight: "bold",
                padding: '0px 0px 20px 0px',
                alignItems: "center"
            }}>
                <div>Settings & Config -</div>
                <div style={{ marginLeft: 5 }}>
                    <Dropdown
                        maxWidth="100%"
                        // label="Menu"
                        value={selectedSettingsPage || ""}
                        name="menu"
                        options={[
                            {
                                value: "/settings-config/forecast-review-period",
                                label: "Forecast Review Period Configuration",
                                Title: "Forecast Review Period Configuration",
                            },
                            {
                                value: "/settings-config/forecast-publish-exclusion",
                                label: "Forecast Publish Restriction",
                                Title: "Forecast Publish Restriction",
                            }
                        ]}
                        handleChange={(event) =>
                            handleSelectedSettingsPageChange("menu", event)
                        }
                    />
                </div>

            </div>
            {selectedSettingsPage === "/settings-config/forecast-review-period" ? (
                <div>

                    <div
                        style={{
                            padding: "10px 0px 20px 0px",
                            marginBottom: 10,
                        }}
                    >
                        {/* Subtitle */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                flexWrap: "wrap",
                            }}
                        >
                            {/* Subtitle */}
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#6b7280",
                                }}
                            >
                                Configure overrides for forecast review periods per Plant /
                                Supplier Combination
                            </div>

                            {/* Info Badge */}
                            <div
                                style={{
                                    background: "#eef2ff",
                                    border: "1px solid #c7d2fe",
                                    color: "#2563eb",
                                    padding: "3px 6px",
                                    borderRadius: 8,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                Default review period: 4 days (applies when no override found)
                            </div>
                        </div>
                    </div>


                    {/* ================= FILTER CARD ================= */}
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: 12,
                            padding: 20,
                            marginBottom: 20,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            border: "1px solid #e5e7eb",
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 20,
                            }}
                        >
                            <h2
                                style={{
                                    margin: 0,
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}
                            >
                                Filters
                            </h2>
                        </div>

                        {/* Filter Controls */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "flex-end",
                                gap: 16,
                                flexWrap: "nowrap",
                                paddingBottom: 4,
                            }}
                        >
                            <div className="filter-item">
                                <span>Plant Code</span>
                                <MultiDropdown
                                    id="plant"
                                    name="plant"
                                    options={filteredPlantOptions}
                                    height={36}
                                    copyPasteDisabled={false}
                                    onChangeItems={handleSelectedItemsChange}
                                    selectedItemsData={filters.plant}
                                    ListboxComponentProps={false}
                                />
                            </div>

                            <div className="filter-item">
                                <span>Parent Vendor</span>
                                <MultiDropdown
                                    id="parentVendor"
                                    name="parentVendor"
                                    options={filteredParentVendorOptions}
                                    height={36}
                                    copyPasteDisabled={false}
                                    onChangeItems={handleSelectedItemsChange}
                                    selectedItemsData={filters.parentVendor}
                                    ListboxComponentProps={false}
                                />
                            </div>

                            <div className="filter-item">
                                <span>Child Vendor</span>
                                <MultiDropdown
                                    id="childVendor"
                                    name="childVendor"
                                    options={filteredChildVendorOptions}
                                    height={36}
                                    copyPasteDisabled={false}
                                    onChangeItems={handleSelectedItemsChange}
                                    selectedItemsData={filters.childVendor}
                                    ListboxComponentProps={false}
                                />
                            </div>

                            <div className="filter-item">
                                <span>Business Category</span>
                                <MultiDropdown
                                    id="category"
                                    name="category"
                                    options={filteredCategoryOptions}
                                    height={36}
                                    copyPasteDisabled={false}
                                    onChangeItems={handleSelectedItemsChange}
                                    selectedItemsData={filters.category}
                                />
                            </div>

                            {/* Buttons */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    flexShrink: 0,
                                    whiteSpace: "nowrap",
                                    paddingTop: 2
                                }}
                            >
                                <ButtonComponent
                                    type="secondary"
                                    maxWidth="120px"
                                    label="Search"
                                    height="36px"
                                    onClick={handleSearch}
                                    disabled={!isSearchEnabled || searchLoading.loading}
                                />

                                <ButtonComponent
                                    type="primary"
                                    maxWidth="120px"
                                    label="Reset"
                                    height="36px"
                                    onClick={handleReset}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ================= GRID CARD ================= */}
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: 12,
                            padding: 20,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            border: "1px solid #e5e7eb",
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 15,
                                flexWrap: "wrap",
                                gap: 10,
                            }}
                        >
                            <h2
                                style={{
                                    margin: 0,
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}
                            >
                                Plant Configuration
                            </h2>

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {isAppAdmin && <ButtonComponent
                                    type="primary"
                                    minWidth="220px"
                                    label="+ Add Plant Configuration"
                                    height="35px"
                                    onClick={onAddPlantConfig}
                                />}

                            </div>
                        </div>

                        {/* Grid */}
                        <div
                            className="ag-theme-quartz"
                            style={{
                                height: 500,
                                width: "100%",
                                borderRadius: 10,
                                overflow: "hidden",
                            }}
                        >
                            <div className="ag-theme-quartz" style={{ height: 400, width: '100%' }}>
                                {searchLoading.loading || plantConfigSelector.loading ? <Loader /> :
                                    <AgGridReact
                                        ref={gridRef}
                                        rowData={rowData}
                                        gridOptions={gridOptions}
                                        columnDefs={columnDefs}
                                        headerHeight={70} // increase header height
                                        onCellValueChanged={onCellValueChanged}
                                        stopEditingWhenCellsLoseFocus={true}
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        paginationPageSizeSelector={paginationPageSizeSelector}
                                        defaultColDef={{
                                            sortable: true,
                                            filter: true,
                                            resizable: true,
                                            flex: 1,
                                            minWidth: 120,
                                        }}
                                    />}
                            </div>
                        </div>
                    </div>

                    <AddPlantConfigurationModal
                        open={openAddModal}
                        onClose={() => {
                            setOpenAddModal(false);
                            setEditRow(null);
                        }}
                        onSubmit={editRow ? handleEditSave : handleAddConfigurations}
                        editData={editRow}   // 👈 ADD THIS
                        plantOptions={plantOptions}
                        parentVendorOptions={parentVendorOptions}
                        childVendorOptions={childVendorOptions}
                        categoryOptions={categoryOptions}
                        allData={allData}   // 👈 ADD THIS
                    />

                    {/* ================= DELETE DIALOG ================= */}
                    <Dialog open={showDelete}>
                        <DialogTitle>
                            Are you sure you want to delete?
                        </DialogTitle>

                        <DialogActions>
                            <Button onClick={() => setShowDelete(false)}>
                                Cancel
                            </Button>

                            <Button
                                color="error"
                                onClick={confirmDelete}
                            >
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>)
                : (
                    <ForecastPublishExclusion />
                )
            }

        </div>
    );
};

export default ForecastReviewPeriodConfig;